export default "__VITE_ASSET__207717f6__"